import {
  IconDigitalBooks,
  IconDoorOpenFill,
  IconImportBookshelf,
  IconImportSeiseki,
  IconImportStudent,
  IconKarteFill,
  IconSectionUsageRate,
  IconTextbookFill,
} from "@studyplus/boron-ui";
import { useMemo } from "react";
import { BackgroundColor } from "../../components/atoms/SubLayout";
import { AI_QUESTION_BETA_AB_TEST_CODE } from "../../components/features/MultiSectionBatches/constants";
import enhanceHomePage from "../../hocs/enhanceHomePage";
import { useFetchAdminSections } from "../../hooks/http/useFetchAdminSections";
import OperatorInterface from "../../interfaces/OperatorInterface";
import { Tile } from "./Tile";

export type MultiSectionBatch = {
  title: string;
  Icon: React.ComponentType<{ className: string }>;
  actions: { name: string; operation: string }[];
};

const multiSectionBatches: MultiSectionBatch[] = [
  {
    title: "学習記録のダウンロード",
    Icon: IconTextbookFill,
    actions: [{ name: "ダウンロード", operation: "download_study_records" }],
  },
  {
    title: "入退室記録のダウンロード",
    Icon: IconDoorOpenFill,
    actions: [{ name: "ダウンロード", operation: "download_stays" }],
  },
  {
    title: "面談記録のダウンロード",
    Icon: IconKarteFill,
    actions: [{ name: "ダウンロード", operation: "download_kartes" }],
  },
  {
    title: "生徒一覧のダウンロード",
    Icon: IconImportStudent,
    actions: [{ name: "ダウンロード", operation: "download_students" }],
  },
  {
    title: "成績記録のダウンロード",
    Icon: IconImportSeiseki,
    actions: [
      { name: "ダウンロード", operation: "download_examination_results" },
    ],
  },
  {
    title: "校舎別活用率のダウンロード",
    Icon: IconSectionUsageRate,
    actions: [
      { name: "ダウンロード", operation: "download_section_usage_rates" },
    ],
  },
  {
    title: "デジタル教材の登録・更新",
    Icon: IconDigitalBooks,
    actions: [
      { name: "登録", operation: "upload_drill" },
      { name: "更新", operation: "upload_drill/list" },
    ],
  },
];

const betaMultiSectionBatches: MultiSectionBatch[] = [
  {
    title: "AI質問詳細のダウンロード (β)",
    Icon: IconImportBookshelf,
    actions: [
      { name: "ダウンロード", operation: "download_ai_question_details" },
    ],
  },
  {
    title: "AI質問回数のダウンロード (β)",
    Icon: IconImportBookshelf,
    actions: [
      { name: "ダウンロード", operation: "download_ai_question_counts" },
    ],
  },
];

type Props = {
  currentOperator: OperatorInterface;
};

const Index = ({ currentOperator }: Props) => {
  const { data } = useFetchAdminSections(currentOperator.id);

  const showBetaTiles = useMemo(() => {
    if (!data?.sections) {
      return false;
    }
    return data.sections.some((section) =>
      section.abTestCodes?.includes(AI_QUESTION_BETA_AB_TEST_CODE),
    );
  }, [data]);

  const tiles = useMemo(() => {
    return showBetaTiles
      ? [...multiSectionBatches, ...betaMultiSectionBatches]
      : multiSectionBatches;
  }, [showBetaTiles]);

  return (
    <div className="md:w-[95%]">
      <div className="">
        <h1 className="text-bold my-10 text-center text-3xl">校舎横断操作</h1>
        <div className="p-10">
          <div className="flex flex-wrap gap-x-10 gap-y-20">
            {tiles.map((tile) => (
              <Tile key={tile.title} {...tile} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const MultiSectionBatchesPage = enhanceHomePage(Index, {
  title: "校舎横断操作",
  backgroundColor: BackgroundColor.Gray,
});
